import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { SpecialCompbaser } from "../../../components/compbaser";
import { StoreSelectorsService } from "../../../services";
import { actionGetSharedCommonContent } from "../../../store/actions/user.actions";
import { IResourcePreview } from "../../../interfaces";
import { IDialogGetAsset } from "../../../components/dialog-get-asset/dialog-get-asset.component";
import { Lib } from "../../../../libs/Lib";

@Component({
    selector: "app-create-resource",
    templateUrl: "./create-resource.component.html",
    styleUrls: ["./create-resource.component.scss"],
    standalone: false
})
export class CreateResourceComponent extends SpecialCompbaser implements OnInit {
    @Input() dialogGetAsset: IDialogGetAsset;
    @Output() itemSelected = new EventEmitter<string>();
    @Output() backClicked = new EventEmitter<void>();

    enterprise = false;
    isUpdatingEnterprise = false;
    importType: 'categories' | 'shared' = 'categories';
    selectedTabIndex: number = 0;

    constructor(private storeSelector: StoreSelectorsService) {
        super();
        this.setMe("create-resource.component.ts");
        this.cod(
            this.storeSelector.getUser().subscribe((user) => {
                this.enterprise = Lib.GetAccountVersion(user) === "ENTERPRISE_08" || Lib.GetAccountVersion(user) === "ENTERPRISE_24";
            }),
        );
    }

    ngOnInit(): void {
        // Component initialization
    }

    getEnterpriseSharedContent() {
        if (this.isUpdatingEnterprise) return;
        this.isUpdatingEnterprise = true;
        return this.storeSelector.dispatch(actionGetSharedCommonContent({ config: null }));
    }

    onResourceSelected(resourceId) {
        if (this.itemSelected) {
            this.itemSelected.emit(resourceId);
        }
    }

    onTabChange(tabIndex: number) {
        this.selectedTabIndex = tabIndex;
        if (tabIndex === 0) {
            this.importType = 'categories';
        } else if (tabIndex === 1) {
            this.importType = 'shared';
            if (this.enterprise) {
                this.storeSelector.dispatch(actionGetSharedCommonContent({ config: null }));
            }
        }
    }

    onBackClick() {
        this.backClicked.emit();
    }
}
